import React, {Component} from 'react';
import { ApplicationContext } from '@/app/context/AppContext';

class Body extends Component {

    constructor(props) {
        super(props);
        this.state = {
            blank: this.props.blank||false
        };
        this.styleBody = this.styleBody.bind(this);
    }

    styleBody(){
        return <style dangerouslySetInnerHTML={this.context.tema.style} />
    }

    render(){
        return (
            <React.Fragment>
                {this.styleBody()}
                <div id={this.context.tema.bodyId} className={"col-12 "+this.props.className}>
                    {this.props.children}
                </div>
            </React.Fragment>
        );
    }
}

Body.contextType = ApplicationContext
export default Body